module.exports = __webpack_public_path__ + "img/news-image2.6e09ba1e.png";